"use strict";

import $ from "jquery";
import scrollToElm from "../../Shared/helpers/helper.scrollToElm.js";

function init() {
    function sendGTM(eventCategory, name, domain, details) {
        if (typeof window.dataLayer !== "undefined") {
            window.dataLayer.push({
                event: "Form submit " + domain,
                eventCategory: eventCategory,
                eventAction: "form submission",
                eventLabel: name + " - " + details,
            });
        }
    }

    // Courses
    $(".js-courses-module").each(function () {
        const module = $(this);
        const moduleLoading = module.find(".js-courses-loading");

        module.find(".js-course").each(function () {
            const course = $(this);
            const courseSuccess = course.find(".js-course-success");
            const courseError = course.find(".js-course-error");
            const formParentDiv = course.find(".js-course-form");

            const form = course.find(".elq-form");
            const formToggle = course.find(".js-course-toggle");

            // toggle form
            formToggle.on("click", function (e) {
                e.preventDefault();
                // hide
                formToggle.fadeOut();
                courseSuccess.slideUp();
                courseError.slideUp();
                // show
                formParentDiv.slideToggle();

                formParentDiv.each(function () {
                    const $iframe = $(this).find(".js-pardot-iframe");

                    if ($iframe.length) {
                        $iframe.get(0).iFrameResizer.resize();
                    }

                    // manually trigger window resize to make tabs module work with iframe resize
                    setTimeout(() => {
                        window.dispatchEvent(new Event("resize"));
                    }, 800);
                });
            });

            form.removeAttr("onsubmit").on("submit", function (e) {
                e.preventDefault();
                if (
                    !!LiveValidationForm.instances[form[0].id] &&
                    LiveValidation.massValidate(
                        LiveValidationForm.instances[form[0].id].fields,
                    )
                ) {
                    // eslint-disable-line
                    moduleLoading.addClass("active");
                    const requestData = {
                        data: form.serialize(),
                        url: form.attr("action"),
                    };
                    $.ajax({
                        url: "/api/EloquaApi/PostForm",
                        type: "POST",
                        data: requestData,
                    })
                        .done(function () {
                            const eventName = course.attr("data-course-name");
                            const details =
                                course.attr("data-location-name") +
                                " - " +
                                course.attr("data-location-datetimes");
                            const domain = course.attr("data-domain-name");
                            sendGTM(
                                "Course Form Submit",
                                eventName,
                                domain,
                                details,
                            );
                            form.trigger("reset");
                            formParentDiv.slideUp();
                            formToggle.fadeIn();
                            courseSuccess.slideToggle();
                            // console.log('success');
                        })
                        .fail(function () {
                            courseError.slideToggle();
                            // console.log('error', data);
                        })
                        .always(function () {
                            scrollToElm(course);
                            moduleLoading.removeClass("active");
                        });
                } else {
                    scrollToElm(course);
                    moduleLoading.removeClass("active");
                }
            });
        });
    });

    // Webinars
    $(".js-webinar-module").each(function () {
        const module = $(this);
        const moduleLoading = module.find(".js-webinar-loading");

        module.find(".js-webinar").each(function () {
            const webinar = $(this);

            const webinarSuccess = webinar.find(".js-webinar-success");
            const webinarError = webinar.find(".js-webinar-error");

            const form = webinar.find(".elq-form");

            form.removeAttr("onsubmit").on("submit", function (e) {
                e.preventDefault();
                if (
                    !!LiveValidationForm.instances[form[0].id] &&
                    LiveValidation.massValidate(
                        LiveValidationForm.instances[form[0].id].fields,
                    )
                ) {
                    // eslint-disable-line
                    moduleLoading.addClass("active");

                    const requestData = {
                        data: form.serialize(),
                        url: form.attr("action"),
                    };

                    $.ajax({
                        url: "/api/EloquaApi/PostForm",
                        type: "POST",
                        data: requestData,
                    })
                        .done(function () {
                            const name = webinar.attr("data-name");
                            const checkboxesText = $.map(
                                $(".elq-form :checkbox:checked"),
                                (e) => $(e).next().text(),
                            ).join(";"); // eslint-disable-line
                            const domain = webinar.attr("data-domain-name");
                            sendGTM(
                                "Webinar Form Submit",
                                name,
                                domain,
                                checkboxesText,
                            );
                            form.trigger("reset");
                            webinarSuccess.slideDown();
                        })
                        .fail(function () {
                            webinarError.slideToggle();
                        })
                        .always(function () {
                            scrollToElm(webinar);
                            moduleLoading.removeClass("active");
                        });
                } else {
                    scrollToElm(webinar);
                    moduleLoading.removeClass("active");
                }
            });
        });
    });
}

export default {
    init,
};
